import { render, staticRenderFns } from "./WxAppTbRelConfig.vue?vue&type=template&id=27aea110"
import script from "./WxAppTbRelConfig.vue?vue&type=script&lang=js"
export * from "./WxAppTbRelConfig.vue?vue&type=script&lang=js"
import style0 from "./WxAppTbRelConfig.vue?vue&type=style&index=0&id=27aea110&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports